var _rect, _rect2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDistribution = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  fill: "#EAF0FD",
  fillOpacity: 0.75,
  rx: 3.931
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  stroke: "#2F64ED",
  rx: 3.931
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F64ED",
  d: "M12.966 6.646h-6.32v6.32m0-6.32 6.646 6.646m-.326 16.062h-6.32v-6.32m0 6.32 6.646-6.646m9.742-16.062h6.32v6.32m0-6.32-6.646 6.646m.326 16.062h6.32v-6.32m0 6.32-6.646-6.646"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18.252,
  r: 2.769,
  stroke: "#2F64ED"
})));
export { SvgDistribution as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgcng9IjMuOTMwNzciIGZpbGw9IiNFQUYwRkQiIGZpbGwtb3BhY2l0eT0iMC43NSIvPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjM1IiByeD0iMy45MzA3NyIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxwYXRoIGQ9Ik0xMi45NjU4IDYuNjQ2MjRMNi42NDYxNiA2LjY0NjI0TDYuNjQ2MTYgMTIuOTY1OSIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxwYXRoIGQ9Ik02LjY0NTkxIDYuNjQ2MjRMMTMuMjkyIDEzLjI5MjMiIHN0cm9rZT0iIzJGNjRFRCIvPgo8cGF0aCBkPSJNMTIuOTY1OCAyOS4zNTM4TDYuNjQ2MTYgMjkuMzUzOEw2LjY0NjE2IDIzLjAzNDEiIHN0cm9rZT0iIzJGNjRFRCIvPgo8cGF0aCBkPSJNNi42NDU5MSAyOS4zNTM4TDEzLjI5MiAyMi43MDc3IiBzdHJva2U9IiMyRjY0RUQiLz4KPHBhdGggZD0iTTIzLjAzNDIgNi42NDYyNEwyOS4zNTM4IDYuNjQ2MjRMMjkuMzUzOCAxMi45NjU5IiBzdHJva2U9IiMyRjY0RUQiLz4KPHBhdGggZD0iTTI5LjM1NDEgNi42NDYyNEwyMi43MDggMTMuMjkyMyIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxwYXRoIGQ9Ik0yMy4wMzQyIDI5LjM1MzhMMjkuMzUzOCAyOS4zNTM4TDI5LjM1MzggMjMuMDM0MSIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxwYXRoIGQ9Ik0yOS4zNTQxIDI5LjM1MzhMMjIuNzA4IDIyLjcwNzciIHN0cm9rZT0iIzJGNjRFRCIvPgo8Y2lyY2xlIGN4PSIxNy45OTk3IiBjeT0iMTguMjUyNCIgcj0iMi43NjkyMyIgc3Ryb2tlPSIjMkY2NEVEIi8+Cjwvc3ZnPgo=";